import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ResponseGetChecksTypes } from './type';

const getToken = () => localStorage.getItem('token');

const getAuthorizationHeader = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : '';
};

export const checksApi = createApi({
  reducerPath: 'checksApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api/worksupport`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  }),
  endpoints: (builder) => ({
    getChecks: builder.query<ResponseGetChecksTypes, void>({
      query: () => ({
        url: '/unregistered-fns-offline-receipts',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetChecksQuery } = checksApi;
